import {Box, SvgIcon} from "@mui/material";
import {colors} from "../../../../theme";
import React from "react";
import {ReactComponent as PhoneIcon} from "../../../../assets/icons/108 Phone.svg";
import {ReactComponent as SupportIcon} from "../../../../assets/icons/119 Support.svg";
import {ReactComponent as MailIcon, ReactComponent as WebIcon} from "../../../../assets/icons/120 Web.svg";
import {ReactComponent as YouTubeIcon} from "../../../../assets/icons/Youtube.svg"
import NavButton from "./NavButton";


const ButtonBoxContainer = () => {
    return <Box>
        <NavButton text={"+43 1 492 55 70"} color={colors.grau}
                   icon={<SvgIcon color={"secondary"} component={PhoneIcon} inheritViewBox/>} link={"tel:+4314925570"}/>
        <NavButton text={"abkinfo@abk.at"} color={colors.magenta}
                   icon={<SvgIcon color={"secondary"} component={MailIcon} inheritViewBox/>} link={"mailto:abkinfo@abk.at"}/>
        <NavButton text={"Support"} color={colors.turkis}
                   icon={<SvgIcon color={"secondary"} component={SupportIcon} inheritViewBox/>} link={"https://www.abk.at/support/kundenservice/"}/>
        <NavButton text={"Tipps und Tricks"} color={colors.hellBlau}
                   icon={<SvgIcon color={"secondary"} component={YouTubeIcon} inheritViewBox/>} link={"https://www.youtube.com/channel/UCyI4PiyKJv6UguDmv3vhGaQ"}/>
        <NavButton text={"abk.at"} color={colors.orange}
                   icon={<SvgIcon color={"secondary"} component={WebIcon} inheritViewBox/>} link={"https://www.abk.at/"}/>
    </Box>
}

export default ButtonBoxContainer